/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasicValueModel
 */
export interface BasicValueModel {
    /**
     * 
     * @type {number}
     * @memberof BasicValueModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BasicValueModel
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BasicValueModel
     */
    value?: number;
}

export function BasicValueModelFromJSON(json: any): BasicValueModel {
    return BasicValueModelFromJSONTyped(json, false);
}

export function BasicValueModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicValueModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function BasicValueModelToJSON(value?: BasicValueModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'value': value.value,
    };
}

